import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class LogoutRoute extends Route {
  @service
  logging;

  @service
  router;

  @service
  session;

  // This route just clears tokens, it's used in the purge tokens auth
  // endpoint. Always land on logged-out, even if the purge itself failed;
  // that page purges again on load.
  async beforeModel() {
    try {
      await this.session.purgeTokens();
    } catch (error) {
      this.logging.pushError(error, 'logout:beforeModel');
    } finally {
      this.router.transitionTo('logged-out');
    }
  }
}
